import { NEW_ADMIN_URL } from 'environment';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/accounts/:account_id/static_rtmps/:id', {
        template: require('./account_static_rtmp.html'),
        controller: 'AccountStaticRtmpController'
    });
})
.controller('AccountStaticRtmpController', function($scope, $routeParams, $window, $log, $modal, Account, AccountStaticRtmp){
    $scope.newAdminURL = NEW_ADMIN_URL;

    $scope.account = Account.get({ id: $routeParams.account_id });

    AccountStaticRtmp.get({account_id: $routeParams.account_id, id: $routeParams.id, include_diagnostics: true}, (data) => {
        $scope.staticRTMP = data;
    });

    $scope.getStatus = function(diagnostics){
        const d = diagnostics || {};
        if (d.broadcasting) {
            return 'Broadcasting';
        } else if (d.connected) {
            return 'Connected';
        } else {
            return 'Offline';
        }
    };

    $scope.getResolution = function(diagnostics) {
        const d = diagnostics || {};
        const height = d.video_height || 0;
        const width = d.video_width || 0;
        if (height == 0 || width == 0) {
            return '';
        }
        return `${width}x${height}`
    }

    $scope.getFrameRate = function(diagnostics) {
        const d = diagnostics || {};
        const frameRate = d.frame_rate || 0;
        if (frameRate == 0) {
            return '';
        }
        return frameRate;
    }

});




// WEBPACK FOOTER //
// ./views/account/account_static_rtmp_controller.js